import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#fff"
      d="M16 16.5a1 1 0 1 0-2 0h2Zm-2-8.438a1 1 0 1 0 2 0h-2ZM20 13a1 1 0 1 0 0-2v2ZM9 12l-.707-.707a1 1 0 0 0 0 1.414L9 12Zm1.793 3.207a1 1 0 0 0 1.414-1.414l-1.414 1.414Zm1.414-5a1 1 0 0 0-1.414-1.414l1.414 1.414ZM6 4h7V2H6v2Zm7 16H6v2h7v-2Zm-8-1V5H3v14h2Zm9-2.5V19h2v-2.5h-2Zm6-5.5H9v2h11v-2ZM8.293 12.707l2.5 2.5 1.414-1.414-2.5-2.5-1.414 1.414Zm1.414 0 2.5-2.5-1.414-1.414-2.5 2.5 1.414 1.414ZM6 20a1 1 0 0 1-1-1H3a3 3 0 0 0 3 3v-2Zm7 2a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1v2Zm0-18a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2ZM6 2a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1V2Zm8 3v3.063h2V5h-2Z"
    />
  </svg>
)
export default SvgComponent
